export const titleColors = {
  0: {
    number1: '#00A75D',
    number0: '#43CA70',
    th: '#00A75D',
    anniversary: '#00A75D',
    orbit0: '#00A75D',
    innerParticles: [
      '#58AB61',
      '#3CA982'
    ],
    outerParticles: [
      '#11A89E',
      '#3CA982',
      '#58AB61',
      '#B2DA1C'
    ]
  },
  1: {
    number1: '#E99430',
    number0: '#FDB950',
    th: '#E99430',
    anniversary: '#E99430',
    orbit0: '#ED920B',
    innerParticles: [
      '#FADF32',
      '#D3D655'
    ],
    outerParticles: [
      '#FDB950',
      '#D3D655',
      '#FADF32',
      '#EBA757'
    ]
  },
  2: {
    number1: '#2E7EDC',
    number0: '#4D98F0',
    th: '#2E7EDC',
    anniversary: '#2E7EDC',
    orbit0: '#4DCAF0',
    innerParticles: [
      '#347BAE',
      '#4D98F0'
    ],
    outerParticles: [
      '#219EAF',
      '#4D98F0',
      '#347BAE',
      '#52BAF5'
    ]
  },
  3: {
    number1: '#219EAF',
    number0: '#20B6BD',
    th: '#219EAF',
    anniversary: '#219EAF',
    orbit0: '#219EAF',
    innerParticles: [
      '#11A89E',
      '#219EAF'
    ],
    outerParticles: [
      '#347BAE',
      '#219EAF',
      '#11A89E',
      '#20B6BD'
    ]
  }
}



export const circlePhase1 = {
  0:  {  left: '10.68%',  top: '35%', width: '5.21%', paddingbottom: '5.21%' },
  1:  {  left: '57.97%',  top: '15.56%', width: '1.46%', paddingbottom: '1.46%' },
  2:  {  left: '16.93%',  top: '73.43%', width: '3.02%', paddingbottom: '3.02%' },
  3:  {  left: '80.05%',  top: '39.91%', width: '5.21%', paddingbottom: '5.21%' },
  4:  {  left: '50.41%',  top: '101.59%', width: '3.39%', paddingbottom: '3.39%' },
  5:  {  left: '74.84%',  top: '18.52%', width: '3.02%', paddingbottom: '3.02%' },
  6:  {  left: '72.4%',   top: '72.59%', width: '1.88%', paddingbottom: '1.88%' },
  7:  {  left: '94.11%',  top: '85.46%', width: '1.25%', paddingbottom: '1.25%' },
  8:  {  left: '12.45%',  top: '17.5%', width: '0.75%', paddingbottom: '0.75%' },
  9:  {  left: '8.23%',   top: '83.43%', width: '0.75%', paddingbottom: '0.75%' },
  10: {  left: '41.25%',  top: '71.39%', width: '0.75%', paddingbottom: '0.75%' },
  11: {  left: '90.31%',  top: '25.83%', width: '0.75%', paddingbottom: '0.75%' },
  12: {  left: '67.86%',  top: '97.04%', width: '0.75%', paddingbottom: '0.75%' }
}


export const circlePhase2 = {
  0:  {  left: '23.75%',  top: '28.67%', width: '5.21%', paddingbottom: '5.21%' },
  1:  {  left: '53.96%',  top: '24.63%', width: '1.46%', paddingbottom: '1.46%' },
  2:  {  left: '20.73%',  top: '66.39%', width: '3.02%', paddingbottom: '3.02%' },
  3:  {  left: '74.27%',  top: '38.83%', width: '5.21%', paddingbottom: '5.21%' },
  4:  {  left: '56.41%',  top: '83.59%', width: '3.39%', paddingbottom: '3.39%' },
  5:  {  left: '66.35%',  top: '16.07%', width: '3.02%', paddingbottom: '3.02%' },
  6:  {  left: '72.4%',   top: '72.59%', width: '1.88%', paddingbottom: '1.88%' },
  7:  {  left: '94.11%',  top: '85.46%', width: '1.25%', paddingbottom: '1.25%' },
  8:  {  left: '12.45%',  top: '17.5%', width: '0.75%', paddingbottom: '0.75%' },
  9:  {  left: '8.23%',   top: '83.43%', width: '0.75%', paddingbottom: '0.75%' },
  10: {  left: '41.25%',  top: '71.39%', width: '0.75%', paddingbottom: '0.75%' },
  11: {  left: '90.31%',  top: '25.83%', width: '0.75%', paddingbottom: '0.75%' },
  12: {  left: '67.86%',  top: '97.04%', width: '0.75%', paddingbottom: '0.75%' }
}



export const circlePhase3 = {
  0:  { left: '9.58%',  top:'60%', width: '6.98%', paddingbottom: '6.98%',  },
  1:  { left: '15.16%', top:'60%', width: '9.48%', paddingbottom: '9.48%',  },
  2:  { left: '22.55%', top:'60%', width: '10.63%', paddingbottom: '10.63%',},
  3:  { left: '30.83%', top:'60%', width: '12.92%', paddingbottom: '12.92%',},
  4:  { left: '39.84%', top:'60%', width: '20.10%', paddingbottom: '20.10%',},
  5:  { left: '56.98%', top:'60%', width: '10.63%', paddingbottom: '10.63%',},
  6:  { left: '64.95%', top:'60%', width: '10.63%', paddingbottom: '10.63%',},
  7:  { left: '73.28%', top:'60%', width: '7.92%', paddingbottom: '7.92%',  },
  8:  { left: '80.26%', top:'60%', width: '3.65%', paddingbottom: '3.65%', },
  9:  { left: '83.07%', top:'60%', width: '3.02%', paddingbottom: '3.02%', },
  10: { left: '85.73%', top:'60%', width: '1.77%', paddingbottom: '1.77%', },
  11: { left: '87.14%', top:'60%', width: '2.60%', paddingbottom: '2.60%', },
  12: { left: '89.38%', top:'60%', width: '1.15%', paddingbottom: '1.15%', }
}

export const circlePhase3_mobile = {
  0:  { left: '25.00%', top: '33.14%',     width: '15.56%',  paddingbottom: '15.56%',  },
  1:  { left: '23.06%', top: '41.22%',     width: '19.44%',  paddingbottom: '19.44%',  },
  2:  { left: '18.06%', top: '52.83%',     width: '29.44%',  paddingbottom: '29.44%',},
  3:  { left: '15.28%', top: '68.06%',     width: '35.00%',  paddingbottom: '35.00%',},
  4:  { left: '6.94%',  top: '88.53%',      width: '51.67%',  paddingbottom: '51.67%',},
  5:  { left: '18.06%', top: '106.33%',     width: '29.44%',  paddingbottom: '29.44%',},
  6:  { left: '18.06%', top: '120.11%',    width: '29.44%',  paddingbottom: '29.44%',},
  7:  { left: '22.22%', top: '131.75%',    width: '20.83%',  paddingbottom: '20.83%',  },
  8:  { left: '28.06%', top: '138.5%',      width: '8.89%',   paddingbottom: '8.89%', },
  9:  { left: '30%',    top: '141.17%',        width: '5%',      paddingbottom: '5%', },
  10: { left: '28.61%', top: '143.5%',      width: '7.78%',   paddingbottom: '7.78%', },
  11: { left: '27.5%',  top: '147.5%',       width: '10.56%',  paddingbottom: '10.56%', },
  12: { left: '30.55%', top: '150.5%',      width: '4.17%',   paddingbottom: '4.17%', }
}

export const circlePhase3_mobile_wide = {
  0:  { left: '25.00%', top: '33.14%',      width: '15.56%',  paddingbottom: '15.56%',  },
  1:  { left: '23.06%', top: '40.22%',      width: '19.44%',  paddingbottom: '19.44%',  },
  2:  { left: '18.06%', top: '48.83%',      width: '29.44%',  paddingbottom: '29.44%',},
  3:  { left: '15.28%', top: '61.06%',      width: '35.00%',  paddingbottom: '35.00%',},
  4:  { left: '6.94%', top: '77.53%',       width: '51.67%',  paddingbottom: '51.67%',},
  5:  { left: '18.06%', top: '93.33%',      width: '29.44%',  paddingbottom: '29.44%',},
  6:  { left: '18.06%', top: '106.11%',     width: '29.44%',  paddingbottom: '29.44%',},
  7:  { left: '22.22%', top: '115.75%',     width: '20.83%',  paddingbottom: '20.83%',  },
  8:  { left: '28.06%', top:'121.5%',       width: '8.89%',   paddingbottom: '8.89%', },
  9:  { left: '30%', top:'123.17%',         width: '5%',      paddingbottom: '5%', },
  10: { left: '28.61%', top:'125.5%',      width: '7.78%',   paddingbottom: '7.78%', },
  11: { left: '27.5%', top:'128%',       width: '10.56%',  paddingbottom: '10.56%', },
  12: { left: '30.55%', top:'130.5%',      width: '4.17%',   paddingbottom: '4.17%', }
}

// export const circlePhase3_mobile = {
//   0:  { left: '25.00%', top: '33.14%',     width: '15.56%',  paddingbottom: '15.56%',  },
//   1:  { left: '23.06%', top: '41.22%',     width: '19.44%',  paddingbottom: '19.44%',  },
//   2:  { left: '18.06%', top: '52.83%',     width: '29.44%',  paddingbottom: '29.44%',},
//   3:  { left: '15.28%', top: '68.06%',     width: '35.00%',  paddingbottom: '35.00%',},
//   4:  { left: '6.94%',  top: '88.53%',      width: '51.67%',  paddingbottom: '51.67%',},
//   5:  { left: '18.06%', top: '106.33%',     width: '29.44%',  paddingbottom: '29.44%',},
//   6:  { left: '18.06%', top: '120.11%',    width: '29.44%',  paddingbottom: '29.44%',},
//   7:  { left: '22.22%', top: '131.75%',    width: '20.83%',  paddingbottom: '20.83%',  },
//   8:  { left: '28.06%', top: '138.5%',      width: '8.89%',   paddingbottom: '8.89%', },
//   9:  { left: '30%',    top: '141.17%',        width: '5%',      paddingbottom: '5%', },
//   10: { left: '28.61%', top: '143.5%',      width: '7.78%',   paddingbottom: '7.78%', },
//   11: { left: '27.5%',  top: '147.5%',       width: '10.56%',  paddingbottom: '10.56%', },
//   12: { left: '30.55%', top: '150.5%',      width: '4.17%',   paddingbottom: '4.17%', }
// }





export const circlePhase2_new = {
  0:  {  left: '23.75%',  top: '28.67%', width: '5.21%', paddingbottom: '5.21%' },
  1:  {  left: '53.96%',  top: '24.63%', width: '1.46%', paddingbottom: '1.46%' },
  2:  {  left: '20.73%',  top: '66.39%', width: '3.02%', paddingbottom: '3.02%' },
  3:  {  left: '74.27%',  top: '38.83%', width: '5.21%', paddingbottom: '5.21%' },
  4:  {  left: '56.41%',  top: '83.59%', width: '3.39%', paddingbottom: '3.39%' },
  5:  {  left: '66.35%',  top: '16.07%', width: '3.02%', paddingbottom: '3.02%' },
  6:  {  left: '72.4%',   top: '72.59%', width: '1.88%', paddingbottom: '1.88%' },
  7:  {  left: '94.11%',  top: '85.46%', width: '1.25%', paddingbottom: '1.25%' },
  8:  {  left: '12.45%',  top: '17.5%', width: '0.75%', paddingbottom: '0.75%' },
  9:  {  left: '8.23%',   top: '83.43%', width: '0.75%', paddingbottom: '0.75%' },
  10: {  left: '41.25%',  top: '71.39%', width: '0.75%', paddingbottom: '0.75%' },
  11: {  left: '90.31%',  top: '25.83%', width: '0.75%', paddingbottom: '0.75%' },
  12: {  left: '67.86%',  top: '97.04%', width: '0.75%', paddingbottom: '0.75%' }
}